// extracted by mini-css-extract-plugin
module.exports = {"sort":"VP","selected":"WP","disabled":"XP"};